import { render, staticRenderFns } from "./AudioViewModal.vue?vue&type=template&id=7c3c12f7&scoped=true&"
import script from "./AudioViewModal.vue?vue&type=script&lang=ts&"
export * from "./AudioViewModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c12f7",
  null
  
)

export default component.exports